import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Modal } from './modal';
import type { useModal } from './use-modal';

interface SimpleConfirmModalType {
  confirmButtonVariant?: ComponentProps<typeof Button>['variant'];
  confirmButtonText?: string;
  onConfirm: () => void | Promise<void>;
  title: string;
  body: string;
  modal: ReturnType<typeof useModal>;
}

export function SimpleConfirmModal({
  modal,
  onConfirm,
  title,
  body,
  confirmButtonText,
  confirmButtonVariant = 'contained',
}: SimpleConfirmModalType) {
  const { t } = useTranslation();

  return (
    <Modal {...modal} title={title} className="max-w-96">
      <Modal.Body>{body}</Modal.Body>
      <Modal.Actions>
        <Button
          data-test-id="confirm-button"
          className="w-1/2"
          variant={confirmButtonVariant}
          onClick={async () => {
            await onConfirm();
            modal.dismiss();
          }}
        >
          {confirmButtonText ?? t('confirm')}
        </Button>
        <Button
          data-test-id="cancel-button"
          className="w-1/2"
          variant="outline"
          onClick={() => {
            modal.dismiss();
          }}
        >
          {t('cancel')}
        </Button>
      </Modal.Actions>
    </Modal>
  );
}
